module.exports = __webpack_public_path__ + "img/汉熵超融合云管理平台.9b46cc08.png";